/* eslint-disable no-useless-constructor */
/* eslint-disable import/no-unresolved */

import { trackBotMessageConversion as GBC_trackBotMessageConversion } from '@sgorg/game-backend-client';

const CAN_SUBSCRIBE_BOT_FEEDBACK = {
  YES: 'YES', // Yes you can subscribe
  NO: 'NO', // No you cannot subscribe
  ALREADY: 'ALREADY', // Like already subscribed
};

/**
* class for handling things related to bots / and bot messaging
*/
export class OMT_Bots {
  /**
   * constructor
   */
  constructor() {
    //
  }

  /**
   * getter for constant so we dont have to import this file
   * @returns {string}
   */
  get CAN_SUBSCRIBE_BOT_FEEDBACK() { return CAN_SUBSCRIBE_BOT_FEEDBACK; }

  /**
   * attempt to subscribe to the game bot
   */
  async subscribeToBot() {
    //const status = await FBInstant.player.subscribeBotAsync();
    return false;//status;
  }

  /**
   * check if the user can subscribe to the game bot
   * Returns 3 strings of YES, NO, and ALREADY
   * @returns {string} CAN_SUBSCRIBE_BOT_FEEDBACK
   */
  async canSubscribeToBot() {
    let result = CAN_SUBSCRIBE_BOT_FEEDBACK.NO;
    try {
      const facebookSays = false;//await FBInstant.player.canSubscribeBotAsync();
      if (facebookSays) {
        result = CAN_SUBSCRIBE_BOT_FEEDBACK.YES;
      }
    } catch (err) {
      if (err) {
        if (err.code === 'INVALID_OPERATION') {
          const lowerMessage = err.message.toLowerCase();
          const alreadySubscribed = lowerMessage.indexOf('already subscribe') > -1;
          if (alreadySubscribed) {
            result = CAN_SUBSCRIBE_BOT_FEEDBACK.ALREADY;
          }
        } else if (err.code === 'RATE_LIMITED') {
          result = CAN_SUBSCRIBE_BOT_FEEDBACK.NO;
        }
      }
    }
    return result;
  }

  /**
   * check if entryPoint was a bot message
   * @returns {boolean} true if bot message
   */
  get entryPointIsBotMsg() {
    const { entryPointData } = OMT.envData;
    return entryPointData.messageId !== undefined;
  }

  /**
   * track bot message coversation in game-backend
   */
  async trackBotConversion() {
    try {
      const { entryPointData } = OMT.envData;
      await GBC_trackBotMessageConversion({ messageId: entryPointData.messageId });
      console.log('GB bot message tracked');
    } catch (error) {
      console.log('Error message', error.message);
      console.log('Error code', error.code);
    }
  }

  get scheduler() {
    return this._scheduler;
  }
}
